import { Flex, Heading, Icon, LinkBox, Text } from "@chakra-ui/react";
import { IconType } from "react-icons";
import { MdArrowForward, MdCheckCircle } from "react-icons/md";
import Link from "components/Shared/Link";
import { UrlObject } from "utils/links";

export type OnboardingSetupStep = {
  id: string;
  title: string;
  description: string;
  href: string | UrlObject;
  isComplete: boolean;
  IconComponent: IconType;
};

type Props = {
  onClick?: () => void;
  step: OnboardingSetupStep;
};

export default function SetupStepTile({ onClick, step }: Props) {
  return (
    <LinkBox
      role="group"
      data-complete={step.isComplete}
      display="flex"
      minHeight="11rem"
      alignItems="stretch"
      p={5}
      borderWidth="1px"
      borderRadius="md"
      background="white"
      borderColor="gray.200"
      _hover={{
        borderColor: "pink.400",
        boxShadow: "md",
      }}
      sx={{
        "&[data-complete=true]": {
          background: "green.50",
          borderColor: "green.200",
        },
        "&[data-complete=true]:hover": {
          borderColor: "green.300",
        },
      }}
    >
      <Flex direction="column" alignItems="flex-start" width="100%" gap={3}>
        <Flex
          alignItems="center"
          justifyContent="center"
          boxSize={12}
          borderRadius="lg"
          background="lightBlueGrey"
          color="magenta.veryDark"
          sx={{
            "[data-complete=true] &": {
              background: "green.500",
              color: "white",
            },
          }}
        >
          <Icon
            as={step.isComplete ? MdCheckCircle : step.IconComponent}
            boxSize={6}
          />
        </Flex>

        <Link
          isLinkOverlay
          href={step.href}
          color="magenta.veryDark"
          fontWeight="700"
          onClick={onClick}
          _hover={{ textDecoration: "none" }}
        >
          <Heading as="h3" size="sm">
            {step.title}
          </Heading>
        </Link>

        <Text fontSize="sm" color="gray.600" lineHeight="short">
          {step.description}
        </Text>

        <Flex
          alignItems="center"
          gap={1}
          mt="auto"
          fontSize="xs"
          fontWeight="700"
          color="pink.500"
          textTransform="uppercase"
          transition="transform 150ms ease"
          sx={{
            "[data-complete=true] &": {
              color: "green.600",
            },
            "[data-complete=false]:hover &": {
              transform: "translateX(0.125rem)",
            },
          }}
        >
          {step.isComplete ? "Completed" : "Start"}
          {!step.isComplete && <Icon as={MdArrowForward} />}
        </Flex>
      </Flex>
    </LinkBox>
  );
}
